import { render } from "./keyboardContact.vue?vue&type=template&id=501a0139&scoped=true"
import script from "./keyboardContact.vue?vue&type=script&lang=js"
export * from "./keyboardContact.vue?vue&type=script&lang=js"

import "./keyboardContact.vue?vue&type=style&index=0&id=501a0139&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501a0139"]])

export default __exports__